var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_4071_17413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4071_17413",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4071_17413",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4071_17413",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABZklEQVRIibXWMWsUQRjG8d/uDWGKkDKoBGys0qW1lNSWInZi7OzNBxFESEggVlYprSzs0+UzxBOsgsUUYbGYHbLcbc49bveBYRhm3/8zO++7L1tBjDHiDd7iCQLqdnS1uC5q2nGHG5zha0opVS38FK9XANZVg294NwshHOHjiHCosI9fsxDCF/laxlaFxzX2JoAX7dVyQqfSVqmWrm7lBP11Xx1Nu1fmujOXsY1X2Omw6j6Dn3ifUlrrqLkY7eJl16Cv1tO68DYIlgL7SvNubfqK2L4ENxBjPJK/7CE6SymduM/RSoOip3g+0ODHQxt9V7R0ik3UZzBmyxgXNtRgE9Ol2GD5zstDVzgfCL7q8P5rECGldInLgQZFWwvrps/gRYzxs9yTyofzUGWVtw1yDzpcNKhijL/lHjKF/tSYTwSHeY2LCQ0uZiGEaxzg2cjw7ziuIMa4gw9yc3u0IXgu/7Z8Sind/gOeaE0ZP9JdggAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize-icon.4313e83d947c899309c561bfabcccaf8.svg";
export { ForwardRef as ReactComponent };